import React from "react";
import { MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: "en", name: "English" },
    { code: "bn", name: "বাংলা" },
    { code: "es", name: "Español" },
    { code: "fr", name: "Français" },
    { code: "hi", name: "हिन्दी" },
    { code: "ne", name: "नेपाली" },
    { code: "pt", name: "Português" },
    { code: "zh_Hant", name: "中文（繁體)" },
    { code: "zh_Hans", name: "中文（简体)" },
  ];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <>
      {languages.map((language) => (
        <MenuItem
          key={language.code}
          onClick={() => handleLanguageChange(language.code)}
          selected={i18n.language === language.code}
        >
          <Typography textAlign="center">{language.name}</Typography>
        </MenuItem>
      ))}
    </>
  );
};

export default LanguageSwitcher;
